import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportClientError } from './error-reporting';
import { ServerErrorContent } from './ServerErrorContent';

/**
 * Catches render errors of a page so the layout (navigation) survives and the user sees the
 * 500 page instead of a blank screen. Resets when the user navigates (key = pathname upstream).
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('page crashed', error, info.componentStack);
    reportClientError('boundary', error);
  }

  override render() {
    return this.state.error ? (
      <ServerErrorContent onRetry={() => this.setState({ error: null })} />
    ) : (
      this.props.children
    );
  }
}
